














import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class InputWithSelect extends Vue {
  @Prop({ default: '' }) readonly selectMaxWidth!: string
}
